<template>
  <sweet-modal width="550" ref="modal">
    <h2>Complete Staff access</h2>
    <p class="mt-3">This will complete the Staff access and create a purchase on the customer.</p>
    <div class="row mt-4">
      <div class="col-4">
        <label>Hours spent: </label>
      </div>
      <div class="col-4">
        <input class="form-control" v-model="staff_access.hours_spent" />
      </div>
    </div>
    <p class="text-warning mt-4" v-if="staff_access.hours_spent">
      Billed price will be {{ staff_access.hours_spent }} x {{ staff_access.price_per_hour }} {{ customer.currency }}
    </p>
    <button class="btn btn-primary mt-3" @click="save()" :disabled="!staff_access.hours_spent">Complete</button>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Alerts, { handle } from '@/utils/alerts';
import Api from '@/store/jsonapi';

export default {
  props: ['customer'],
  data: function () {
    return {
      staff_access: {}
    };
  },
  methods: {
    save: function () {
      Api.update('staff_accesses', {
        id: this.staff_access.id,
        completed: true,
        hours_spent: this.staff_access.hours_spent
      })
        .then(({ data }) => {
          this.staff_access.completed = data.completed;
          this.staff_access.end_time = data.end_time;
          Alerts.success({
            title: 'Success',
            detail: 'Staff access completed'
          });
          this.$refs.modal.close();
        })
        .catch(({ errors }) => {
          Alerts.danger(errors[0]);
        });
    },
    open: async function (staff_access) {
      this.staff_access = staff_access;
      this.$refs.modal.open();
    }
  }
};
</script>
